// extracted by mini-css-extract-plugin
export var emailBlockLink = "_il-0";